<template>
    <div class="row mx-auto my-2 py-4">
        <div class="col-md-3 p-0 mx-auto">
            <qr-maker></qr-maker>
        </div>
        <div class="col-md mx-auto p-3">
            <div class="row mx-auto">
                <v-expansion-panels class="px-1">
                    <v-expansion-panel class="mb-1">
                        <v-expansion-panel-header class="text-right">
                            رمزارزها
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="col-md-12 mx-auto">
                                <v-radio-group class="mt-0 pt-0 px-0 mx-0" row v-model="data.kind">
                                    <v-radio
                                            value="BTC"
                                            label="بیت کوین"
                                    >
                                    </v-radio>
                                    <v-radio
                                            label="اتر"
                                            value="ETH"
                                            class="my-2"
                                    ></v-radio>
                                </v-radio-group>
                            </div>
                            <div class="row mx-auto">
                                <div class="col-md-6 mx-auto">
                                    <v-text-field outlined
                                              dense
                                              v-model="data.amount"
                                              hint="لطفا مقدار رمز ارز خود را وارد کنید."
                                              maxLength="50"
                                              counter="50"
                                              label="مقدار"
                                              append-icon="mdi-coin"/>
                                </div>
                                <div class="col-md-6 mx-auto">
                                    <v-text-field outlined
                                              dense
                                              v-model="data.receiver"
                                              hint="لطفا نام دریافت کننده رمزارز را وارد کنید."
                                              maxLength="50"
                                              counter="50"
                                              label="نام دریافت کننده "
                                              append-icon="mdi-human"/>
                                </div>
                            </div>
                            <div class="col-md-12 mx-auto">
                                <v-textarea outlined
                                            dense
                                            rows="4"
                                            v-model="data.message"
                                            hint="لطفا متن موردنظر خود را وارد کنید."
                                            maxLength="50"
                                            counter="50"
                                            label="متن "
                                            append-icon="mdi-pencil"/>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <qr-generator></qr-generator>
        </div>
    </div>
</template>

<script>
import QrGenerator from "./components/qrGenerator";
import QrMaker from "./components/qrMaker";
export default {
    name: "qrCoins",
    components: {QrMaker, QrGenerator},
    data(){
        return{
            data:{
                kind:'',
                amount:'',
                receiver:'',
                message:'',

            }
        }
    }
}
</script>

<style scoped>

</style>